import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAllMaterialByWorkOrderIdAsync } from '@application/features/materials/MaterialThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
const InvoiceAmountViewTable = ({ formData, handleFieldChange, isInvoiceAmountTabBold }) => {
    const dispatch = useAppDispatch();
    const [gridMaterials, setGridMaterials] = useState();
    const { materials } = useAppSelector((state) => state.material);
    //const { SelectedWorkorderMaterialsList } = useAppSelector((state: RootState) => state.material);
    useEffect(() => {
        if (formData.workOrderId) {
            setGridMaterials([]);
            dispatch(getAllMaterialByWorkOrderIdAsync(formData.workOrderId)).unwrap().then((res) => {
                const updatedMaterials = res.map((material, index) => {
                    if (material.unit === 'Uren') {
                        return {
                            ...material,
                            quantity: material.externalHours,
                        };
                    }
                    return material;
                });
                const updatedMaterialsPosition = updatedMaterials.map((material, index) => {
                    return {
                        ...material,
                        position: index + 1
                    };
                });
                handleFieldChange('materials', updatedMaterialsPosition);
                handleFieldChange('quotations', null);
                setGridMaterials(res);
                if (isInvoiceAmountTabBold && res.length > 0) {
                    isInvoiceAmountTabBold(true);
                }
                else {
                    isInvoiceAmountTabBold && isInvoiceAmountTabBold(false);
                }
            });
        }
    }, [formData.workOrderId]);
    // useEffect(() => {
    //     if (SelectedWorkorderMaterialsList == null) {
    //         dispatch(getAllMaterialByWorkOrderIdAsync(formData.workOrderId)).unwrap().then((res) => {
    //             handleFieldChange('materials', null);
    //             setGridMaterials(res);
    //             if(isInvoiceAmountTabBold && res.length>0){
    //                 isInvoiceAmountTabBold(true)
    //          }
    //          else{
    //             isInvoiceAmountTabBold && isInvoiceAmountTabBold(false)
    //          }
    //         });
    //     }
    // }, [formData.workOrderId]);
    // useEffect(() => {
    //     if (SelectedWorkorderMaterialsList) {
    //         const updatedMaterials = SelectedWorkorderMaterialsList.map((material,index) => {
    //             if (material.unit === 'Uren') {
    //                 return {
    //                     ...material,
    //                     quantity: material.externalHours,
    //                 };
    //             }
    //             return material;
    //         });
    //         const updatedMaterialsPosition = updatedMaterials.map((material, index) => {
    //             return {
    //                 ...material, 
    //                 position: index + 1  
    //             };
    //         });
    //         setGridMaterials(SelectedWorkorderMaterialsList);
    //         handleFieldChange('materials', updatedMaterialsPosition);
    //         handleFieldChange('quotations', null);
    //         // formData.materials = SelectedWorkorderMaterialsList;
    //         if(isInvoiceAmountTabBold && SelectedWorkorderMaterialsList.length>0){
    //             isInvoiceAmountTabBold(true)
    //      }
    //      else{
    //         isInvoiceAmountTabBold && isInvoiceAmountTabBold(false)
    //      }
    //         dispatch(clearSelectedWorkorderMaterialItemsList());
    //     }
    // }, [SelectedWorkorderMaterialsList]);
    return (_jsx(_Fragment, { children: _jsx("div", { className: 'custom-table-container mt-5', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", { children: _jsx("span", { className: 'header-caption', children: "#" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Omschrijving" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aantal" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Prijs(\u20AC)" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bedrag(\u20AC)" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: gridMaterials &&
                                    gridMaterials?.map((material, index) => (_jsxs("tr", { style: { cursor: 'pointer' }, children: [_jsx("td", { className: 'pt-4', children: _jsx("span", { children: index + 1 }) }), _jsx("td", { className: 'pt-4', children: material.unit === 'Uren' ? (_jsx("span", { className: 'vn-multiline-text', children: material.data })) : (_jsxs("span", { className: 'vn-multiline-text', children: [material.name, material.brand && (_jsxs(_Fragment, { children: [_jsx("br", {}), material.brand] })), material.type && (_jsxs(_Fragment, { children: [_jsx("br", {}), material.type] })), material.data && (_jsxs(_Fragment, { children: [_jsx("br", {}), material.data] }))] })) }), _jsx("td", { className: 'pt-4', children: material.unit === 'Uren' ? (_jsx("span", { className: 'mt-2', children: material.externalHours?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) })) : (_jsx("span", { className: 'mt-2', children: material.quantity?.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) })) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { children: material.sellingPrice }) }), _jsx("td", { className: 'pt-4', children: _jsx("span", { className: 'mt-2', children: material.unit === 'Uren'
                                                        ? material.externalHours && material.sellingPrice
                                                            ? (material.sellingPrice * material.externalHours)
                                                                .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                            : 0
                                                        : material.quantity && material.sellingPrice
                                                            ? (material.quantity * material.sellingPrice)
                                                                .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                            : 0 }) })] }, material.id))) })] }) }) }) }) }));
};
export default InvoiceAmountViewTable;
